const endpoints = {
  momos: {
    meta: {
      master_category: 'momos/third-party-links/master-categories',
    },
    microsite: {
      default: '/momos/microsite/brand',
      subscribe: '/momos/microsite/brand/:slug/subscribe',
      unsubscribe: '/momos/microsite/brand/:slug/unsubscribe',
      robotsDisallow: 'momos/microsite/robots-disallow',
    },
    survey: {
      default: 'momos/survey',
      analytics: 'momos/survey/analytics/ga/event',
      voucher: 'momos/vouchers/by-survey',
      csatEligibility: 'momos/survey/:slug/:surveyId/csat-eligibility',
    },
    staff: {
      list: 'momos/staff/list',
    },
    vouchers: {
      default: 'momos/vouchers',
      instances: 'momos/vouchers/instances',
      multiple: 'momos/vouchers/multiple',
    },
    brands: {
      default: 'momos/brand',
    },
    inquiryForm: {
      default: 'momos/inquiry-form',
      getFormById: 'momos/inquiry-form/id',
    },
    review: {
      basicDetails: 'momos/reviews',
    },
    termsAndConditions: {
      bySlug: 'momos/terms-and-conditions/slug',
      languagesBySlug: 'momos/terms-and-conditions/slug',
    },
    optIn: {
      default: 'momos/opt-in',
    },
    shorturl: {
      tracking: 'momos/short-url/tracking',
    },
  },
  facebook: {
    graph: 'https://graph.facebook.com',
  },
  fraudValidator: {
    firehouse: 'momos/fraud-validator/firehouse',
    firehouseToast: 'momos/fraud-validator/firehouse-toast',
    validateStoreId: 'momos/fraud-validator/validate-store-id',
    popeyes: 'momos/fraud-validator/popeyes',
    popeyesSmg: 'momos/fraud-validator/popeyes-smg',
    burgerKing: 'momos/fraud-validator/burger-king',
    // GEN-24519. Same body as burgerKing above, plus which fleet the store is on. A separate
    // endpoint so the one the existing bk-survey link calls keeps its exact response.
    burgerKingStore: 'momos/fraud-validator/burger-king-store',
    burgerKingXpient: 'momos/fraud-validator/burger-king-xpient',
    timhortons: 'momos/fraud-validator/timhortons',
    par: 'momos/fraud-validator/par',
  },
};

export default endpoints;
